// Pure helpers for the Quality Signals reports feed. Kept out of the .tsx so
// they're unit-testable (and to satisfy react-refresh/only-export-components).

// Human-friendly label for the report_type badge. The agentic reporter tags its
// daily rollups `agentic_daily`; readers shouldn't see the internal term.
export const CADENCE_LABELS: Record<string, string> = {
  agentic_daily: 'Daily',
  daily: 'Daily',
  weekly: 'Weekly',
  on_demand: 'On-demand',
  roadmap: 'Roadmap',
};

/**
 * Map a raw report_type to a reader-friendly cadence label. Known types get a
 * curated label; unknown types fall back to their value with underscores
 * spaced out; null/empty returns null (the badge is then not rendered).
 */
export function cadenceLabel(reportType: string | null): string | null {
  if (!reportType) return null;
  return CADENCE_LABELS[reportType] ?? reportType.replace(/_/g, ' ');
}
